import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import axios from "axios";
import Card from "components/card";
import { readToken } from "utils/session";

const FleetSummaryAreaChart = () => {
  const [lineGraphInfo, setLineGraphInfo] = useState([]);

  // Fetch user API key from localStorage
  const USERKEY = readToken();
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const config = {
      method: 'get',
      maxBodyLength: Infinity,
      url: `${apiBaseUrl}/api/fleetsummary`,
      headers: {
        Authorization: `Bearer ${USERKEY}`,
      },
    };

    axios
      .request(config)
      .then((response) => {
        const data = response.data.summaryitems[0].LineChartInfo.LineChartData;

        // Map the data into multiple line graph info format
        const formattedData = data.map((item) => {
          const plotData = item.plotData;

          return {
            plotName: item.plotName,
            plottype: item.plottype,
            lineGraphInfo: {
              timestamps: plotData.timestamps,
              datasets: [
                {
                  label: plotData.displayname.battery,
                  data: plotData.battery,
                  yaxisLabel: "Battery",
                  type: "line", // line chart type
                },
                {
                  label: plotData.displayname.temperature,
                  data: plotData.temperature,
                  yaxisLabel: "Temperature",
                  type: "area", // area chart type
                },
                {
                  label: plotData.displayname.vibration,
                  data: plotData.vibration,
                  type: "line", // line chart type
                },
              ],
            },
          };
        });

        setLineGraphInfo(formattedData);
      })
      .catch((error) => {
        console.error(error);
      });
  }, [USERKEY,apiBaseUrl]);

  if (lineGraphInfo.length === 0) return <div>Loading...</div>;

  return (
    <div className="grid gap-5" style={{ gridTemplateColumns: `repeat(${Math.min(lineGraphInfo.length, 4)}, minmax(0, 1fr))` }}>
      {lineGraphInfo.map((config, index) => {
        const options = {
          chart: {
            type: "line", // Default to line
            height: 380,
            toolbar: { show: false },
          },
          stroke: { width: [3, 3, 2], curve: "smooth" }, // Define line widths
          fill: {
            type: ["solid", "gradient"], // Gradient for the area chart
            gradient: {
              shadeIntensity: 1,
              opacityFrom: 0.7,
              opacityTo: 0.3,
              stops: [0, 90, 100],
            },
          },
          dataLabels: { enabled: false },
          markers: { size: 5 },
          xaxis: {
            categories: config.lineGraphInfo.timestamps,
            title: { text: "Timestamps" },
          },
          yaxis: [
            {
              // title: { text: "Battery" },
              labels: { style: { colors: "#008FFB" } },
            },
            {
              // title: { text: "Temperature" },
              labels: { style: { colors: "#FEB019" } },
              opposite: true, // Position the second axis on the opposite side
            },
          ],
          tooltip: {
            shared: true,
            intersect: false,
          },
          legend: { position: "top" },
        };

        const series = config.lineGraphInfo.datasets.map((dataset) => ({
          name: dataset.label,
          type: dataset.type || "line", // Default to line if no type is defined
          data: dataset.data,
        }));

        return (
          <Card key={index} extra="rounded-[20px] p-3 h-[450px] relative">
            <div className="flex flex-row justify-between px-3 pt-2">
              <h4 className="text-lg font-bold text-navy-700 dark:text-white">
                {config.plotName}
              </h4>
            </div>
            <div className="mb-auto flex h-[380px] w-full items-center justify-center">
              <ReactApexChart
                options={options}
                series={series}
                type="line"
                height={380}
                width={480}
              />
            </div>
          </Card>
        );
      })}
    </div>
  );
};

export default FleetSummaryAreaChart;
